import React from "react";

import styled from "styled-components/macro";
import Footer, { CreateAccountFooter } from "components/Footer";

const $Footer = styled(Footer)`
  position: relative;
  margin: 0 auto;
  width: 90%;
  border: none;
`;

const $CreateAccountFooter = styled(CreateAccountFooter)`
  position: relative;
  margin: 0 auto;
  width: 90%;
`;

export type GuestLayoutFooterProps = {
  userType: "teacher" | "student";
  showCreateAccount: boolean;
  isOnDarkBackground?: boolean;
};

export default function GuestLayoutFooter({
  userType,
  showCreateAccount,
  isOnDarkBackground,
}: GuestLayoutFooterProps) {
  return showCreateAccount ? (
    <$CreateAccountFooter />
  ) : (
    <$Footer userType={userType} isOnDarkBackground={isOnDarkBackground} />
  );
}
